import { render } from "./currencies-modal.vue?vue&type=template&id=23ab37f8"
import script from "./currencies-modal.vue?vue&type=script&lang=js"
export * from "./currencies-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__